<template>
  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
    <component
      :is="product.url ? 'a' : 'div'"
      v-bind="
        product.url
          ? {
              target: 'blank',
              href: product.url,
            }
          : {}
      "
      class="flex-shrink-0"
    >
      <img v-if="cover" class="h-48 w-full object-cover" :src="cover.url" />
      <div v-else class="h-48 w-full object-cover bg-gray-400" />
    </component>
    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
      <div class="flex-1">
        <p class="text-xl font-semibold text-gray-900">
          {{ product.name }}
        </p>
        <ul class="flex -mx-1 mt-2">
          <li v-for="tag in tags" :key="tag.id" class="p-1">
            <span
              class="inline-flex items-center px-2.5 py-0.5 focus:outline-none rounded-full text-xs font-medium bg-gray-100 text-gray-800"
            >
              {{ tag.name }}
            </span>
          </li>
        </ul>
        <p class="mt-3 text-base text-gray-500">
          {{ product.description }}
        </p>
      </div>
      <div class="mt-6 flex items-center justify-between">
        <div class="flex-shrink-0">
          <div class="flex space-x-1 text-sm text-gray-500">Price</div>
          <p class="text-lg font-bold text-gray-900">
            {{ currencyFormattedPrice }}
          </p>
        </div>
        <div class="space-x-2">
          <BaseButton v-if="product.requirements" ghost @click="viewProductRequirements">
            View
          </BaseButton>
          <BaseButton tag="router-link" primary :to="to"> Buy </BaseButton>
        </div>
      </div>
    </div>
    <div v-if="$isSuperAdmin" class="p-2 bg-gray-100">
      <BaseButton
        primary
        outline
        tag="router-link"
        :to="toAdminProductPage"
        class="w-full text-center"
      >
        Go to product
      </BaseButton>
    </div>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cover() {
      return this.product?.media?.[0] || null;
    },
    currencyFormattedPrice() {
      return Numbro(this.product?.price || 0).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
    tags() {
      return (this.product?.tags || []).map((id) => this.$store.state.entities.tags.byId[id]);
    },
    to() {
      const name = {
        basic: 'accounts.products.basicProducts.basicProduct',
        package: 'accounts.products.packages.package',
        service: 'accounts.products.services.service',
      };

      const { id, type } = this.product;

      const key = {
        basic: 'basicProductId',
        package: 'packageId',
        service: 'serviceId',
      };

      return {
        name: name[type] || name.basic,
        params: { [key[type]]: id },
      };
    },
    toAdminProductPage() {
      const name = {
        basic: 'admin.products.basicProducts.basicProduct',
        package: 'admin.products.packages.package',
        service: 'admin.products.services.service',
        membership: 'admin.products.memberships.membership',
      };

      const { id, type } = this.product;

      const key = {
        basic: 'basicProductId',
        package: 'packageId',
        service: 'serviceId',
        membership: 'productId',
      };

      return {
        name: name[type] || name.basic,
        params: { [key[type]]: id },
      };
    },
  },
  methods: {
    viewProductRequirements() {
      this.$modal.show({
        component: 'ProductRequirementsViewModal',
        props: {
          productId: this.product?.id,
        },
        hideEvent: 'closed',
      });
    },
  },
};
</script>
